import repository from "@/api/Main/notificationSettings";

export default {
  state: {
    notification_settings: [],
    notification_departments: [],
    audience_groups: [],
    notification_settings_loading: false,
  },

  getters: {
    GET_NOTIFICATION_SETTINGS: (state) => state.notification_settings,
    GET_NOTIFICATION_DEPARTMENTS: (state) => state.notification_departments,
    GET_AUDIENCE_GROUPS: (state) => state.audience_groups,
    NOTIFICATION_SETTINGS_LOADING: (state) => state.notification_settings_loading,
  },

  mutations: {
    SET_NOTIFICATION_SETTINGS(state, { data, departments, audience_groups }) {
      state.notification_settings = data;
      state.notification_departments = departments;
      state.audience_groups = audience_groups || [];
    },
    UPDATE_NOTIFICATION_SETTING(state, updated) {
      const idx = state.notification_settings.findIndex((s) => s.id === updated.id);
      if (idx !== -1) state.notification_settings.splice(idx, 1, updated);
    },
    SET_AUDIENCE_GROUPS(state, groups) {
      state.audience_groups = groups;
    },
    ADD_AUDIENCE_GROUP(state, group) {
      state.audience_groups.push(group);
    },
    UPDATE_AUDIENCE_GROUP(state, updated) {
      const idx = state.audience_groups.findIndex((g) => g.id === updated.id);
      if (idx !== -1) state.audience_groups.splice(idx, 1, updated);
    },
    REMOVE_AUDIENCE_GROUP(state, id) {
      state.audience_groups = state.audience_groups.filter((g) => g.id !== id);
    },
    SET_NOTIFICATION_SETTINGS_LOADING(state, val) {
      state.notification_settings_loading = val;
    },
  },

  actions: {
    async fetchNotificationSettings({ commit }) {
      commit("SET_NOTIFICATION_SETTINGS_LOADING", true);
      try {
        const res = await repository.index();
        commit("SET_NOTIFICATION_SETTINGS", {
          data: res.data.data,
          departments: res.data.departments,
          audience_groups: res.data.audience_groups,
        });
      } finally {
        commit("SET_NOTIFICATION_SETTINGS_LOADING", false);
      }
    },

    async updateNotificationSetting({ commit }, { id, payload }) {
      const res = await repository.update(id, payload);
      commit("UPDATE_NOTIFICATION_SETTING", res.data.data);
      return res.data;
    },

    async postAnnouncement(_, payload) {
      const res = await repository.postAnnouncement(payload);
      return res.data;
    },

    async fetchAudienceGroups({ commit }) {
      const res = await repository.audienceGroups();
      commit("SET_AUDIENCE_GROUPS", res.data.data);
      return res.data.data;
    },

    async createAudienceGroup({ commit }, payload) {
      const res = await repository.createAudienceGroup(payload);
      commit("ADD_AUDIENCE_GROUP", res.data.data);
      return res.data;
    },

    async updateAudienceGroup({ commit }, { id, payload }) {
      const res = await repository.updateAudienceGroup(id, payload);
      commit("UPDATE_AUDIENCE_GROUP", res.data.data);
      return res.data;
    },

    async deleteAudienceGroup({ commit }, id) {
      const res = await repository.deleteAudienceGroup(id);
      commit("REMOVE_AUDIENCE_GROUP", id);
      return res.data;
    },
  },
};
